import type { LightingSettings } from "../render/Lighting";

// TODO: testing only, remove later
export const HIGHLIGHTED_TILE_COLOR = "#ffcc00";
export const CAPTURABLE_TILE_COLOR = "#ff4400";
export const MOVE_ARROW_SCALE = 0.01;
export const MOVE_ARROW_HEIGHT_ABOVE_TILE = 0.05;

export const TILE_ANIMATION_SECONDS = 0.15;
export const TILE_ANIMATION_TRAVEL_DISTANCE = 1.5;

export const VIEW_HEIGHT = 10;
export const CAMERA_PITCH_DEGREES = 55;
export const CAMERA_MIN_PITCH_DEGREES = 15;
export const CAMERA_YAW_DEGREES = 45;
export const CAMERA_DISTANCE = 40;
export const CAMERA_GIZMO_RADIANS_PER_DRAG_ACROSS = 2 * Math.PI;
export const CAMERA_GIZMO_SCREEN_HEIGHTS_PER_DRAG_ACROSS = 1;
export const CAMERA_ZOOM_BUTTON_FACTOR = 1.25;

// TODO: copied from the viewer and can be tuned later
export const BOARD_LIGHTING: LightingSettings = {
  sun: { color: "#fff4e0", intensity: 2.2, direction: [3, 6, 4] },
  sky: { skyColor: "#dfe8ff", groundColor: "#3a3228", intensity: 0.4 },
  environmentIntensity: 0.45,
  shadowMapSize: 2048,
  shadowBias: -0.0005
};

export const HEAP_SCALE = 0.6;
export const HEAP_SINK_DEPTH = 0.15;
export const HEAP_COLOR = "#777777";
